
import React, { useEffect, useState } from "react";
//import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AuthService from "../services/auth.service";
import authHeader from "../services/auth-header";

import { useTranslation } from "react-i18next";


const api = require("../api/names.js");



function DetectorDetails(props) {
  const { t } = useTranslation("common");
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [itemsVersion, setItemsVersion] = useState([]);



    useEffect(() => {
      const user = AuthService.getCurrentUser();
      if (user) {
        setCurrentUser(user);
        setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
        setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
      }
      var url = api.baseUrl+'/detectorsCurrentValues/WithMetadataByAddress/';
      url += props.address;
      //console.log(url);
      fetch(url, {
    method: 'get',
    headers: authHeader()
    })
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(result);
          setIsLoaded(true);
          setItems(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )

      url = api.baseUrl+'/detectorsVersion/ByAddress/';
      url += props.address;
      //console.log(url);
      fetch(url, {
    method: 'get',
    headers: authHeader()
    })
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(result);
          setIsLoaded(true);
          setItemsVersion(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )

      const interval = setInterval(() => {
        var url = api.baseUrl+'/detectorsCurrentValues/WithMetadataByAddress/';
        url += props.address;
        //console.log(url);
        fetch(url, {
      method: 'get',
      headers: authHeader()
      })
        .then(res => res.json())
        .then(
          (result) => {

            setIsLoaded(true);
            setItems(result);
            //console.log(items);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )



    //console.log('This will be called every 10 seconds');
  }, 10000);
      return () => clearInterval(interval);
    },[])

    if (error) {
       return <div>{t('detectord.error')}{error.message}</div>;
     } else if (!isLoaded) {
      return <div>{t('detectord.loading')}</div>;
     } else {
       return (

         <div>
         <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        <Typography>{t('detectord.current')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          {items.map(item => (

            <TableContainer component={Paper}>
             <Table sx={{ minWidth: 650 }} aria-label="simple table">
               <TableHead>
                  <TableRow>
                    <TableCell>{t('detectord.id')}</TableCell>
                    <TableCell>{t('detectord.busy')}</TableCell>
                   {currentUser.id == 4 && (<TableCell>Radar</TableCell>)}
                   {currentUser.id == 4 && (<TableCell>X</TableCell>)}
                   {currentUser.id == 4 && (<TableCell>Y</TableCell>)}
                    {currentUser.id == 4 && (<TableCell>{t('detectord.temperature')}</TableCell>)}
                    <TableCell >{t('detectord.battery')}</TableCell>
                    {currentUser.id == 4 && (<TableCell>{t('detectord.frame')}</TableCell>)}
                    {currentUser.id == 4 && (<TableCell>{t('detectord.state')}</TableCell>)}
                    <TableCell >{t('detectord.status')}</TableCell>

                 </TableRow>
               </TableHead>
               <TableBody>
                 {items.map(item => (
                   <TableRow
                     key={item.id}
                     sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                   >
                    <TableCell >{item.address}</TableCell>
                    <TableCell >{item.isBusy}</TableCell>
                     {currentUser.id == 4 && (<TableCell >{item.radar}</TableCell>)}
                     {currentUser.id == 4 && (<TableCell >{item.x}</TableCell>)}
                     {currentUser.id == 4 && (<TableCell >{item.y}</TableCell>)}
                     {currentUser.id == 4 && (<TableCell >{item.temperature}</TableCell>)}
                     <TableCell >{item.battery}</TableCell>
                     {currentUser.id == 4 && (<TableCell >{item.frameType}</TableCell>)}
                     {currentUser.id == 4 && (<TableCell >{item.stateChange}</TableCell>)}
                     {/*<TableCell >{item.timestamp}</TableCell>*/}
                     <TableCell >{item.updatedAt}</TableCell>
                   </TableRow>
                 ))}
               </TableBody>
             </Table>
           </TableContainer>

          ))}
          </Typography>
        </AccordionDetails>
      </Accordion>
    {currentUser.id == 4 && (  <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
        <Typography>{t('detectord.metadata')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <TableContainer component={Paper}>
         <Table sx={{ minWidth: 650 }} aria-label="simple table">
           <TableHead>
              <TableRow>
              <TableCell>{t('detectord.address')}</TableCell>
              <TableCell>{t('detectord.appid')}</TableCell>
              <TableCell >{t('detectord.timestamp')}</TableCell>
              <TableCell >{t('detectord.frequency')}</TableCell>
              <TableCell>{t('detectord.modulation')}</TableCell>
              <TableCell>SF</TableCell>
              <TableCell >{t('detectord.airtime')}</TableCell>
              <TableCell >{t('detectord.codingrate')}</TableCell>

              <TableCell>{t('detectord.gatewayid')}</TableCell>
              <TableCell>{t('detectord.gatewaytimestamp')}</TableCell>
              <TableCell >{t('detectord.channel')}</TableCell>
              <TableCell >RSSI</TableCell>
              <TableCell>SNR</TableCell>
              <TableCell>{t('detectord.rfchain')}</TableCell>
              <TableCell >{t('detectord.counter')}</TableCell>
              <TableCell >{t('detectord.updateat')}</TableCell>
             </TableRow>
           </TableHead>
           <TableBody>
             {items.map(item => (
               <TableRow
                 key={item.id}
                 sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
               >
                <TableCell >{item.detectorsMetadatum.address}</TableCell>
                <TableCell >{item.detectorsMetadatum.appID}</TableCell>
                 <TableCell >{item.detectorsMetadatum.lnsTimeStamp}</TableCell>
                 <TableCell >{item.detectorsMetadatum.frequency}</TableCell>
                 <TableCell >{item.detectorsMetadatum.modulation}</TableCell>
                 <TableCell >{item.detectorsMetadatum.dataRate}</TableCell>
                  <TableCell >{item.detectorsMetadatum.airtime}</TableCell>
                  <TableCell >{item.detectorsMetadatum.codingRate}</TableCell>
                  <TableCell >{item.detectorsMetadatum.gatewayID}</TableCell>
                  <TableCell >{item.detectorsMetadatum.gatewayTimestamp}</TableCell>
                  <TableCell >{item.detectorsMetadatum.channel}</TableCell>
                  <TableCell >{item.detectorsMetadatum.rssi}</TableCell>
                  <TableCell >{item.detectorsMetadatum.snr}</TableCell>
                  <TableCell >{item.detectorsMetadatum.rfChain}</TableCell>
                  <TableCell >{item.detectorsMetadatum.counter}</TableCell>
                  <TableCell >{item.detectorsMetadatum.updatedAt}</TableCell>
               </TableRow>
             ))}
           </TableBody>
         </Table>
       </TableContainer>
        </AccordionDetails>
      </Accordion>)}
      {currentUser.id == 4 && ( <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
               <Typography>{t('detectord.version')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <TableContainer component={Paper}>
         <Table sx={{ minWidth: 650 }} aria-label="simple table">
           <TableHead>
              <TableRow>
              <TableCell>{t('detectord.address')}</TableCell>
              <TableCell>{t('detectord.version')}</TableCell>
              <TableCell >{t('detectord.compilation')}</TableCell>
              <TableCell >PCB</TableCell>
              <TableCell>{t('detectord.hardware')}</TableCell>

             </TableRow>
           </TableHead>
           <TableBody>
             {itemsVersion.map(item => (
               <TableRow
                 key={item.id}
                 sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
               >
                <TableCell >{item.address}</TableCell>
                <TableCell >{item.version}</TableCell>
                 <TableCell >{item.compilation}</TableCell>
                 <TableCell >{item.pcb}</TableCell>
                 <TableCell >{item.hardware}</TableCell>

               </TableRow>
             ))}
           </TableBody>
         </Table>
       </TableContainer>
        </AccordionDetails>
      </Accordion> )}


        </div>



       );
     }
   }

export default DetectorDetails;
